/**
 * SCALE LABELS
 * Pure rules on the custom labels of the answer scales : never identical in a language, filled in every language
 */

//Custom labels are stored in the options of the template : response<count>Label_<key>_<language>
const SCALES: { count: number; keys: string[] }[] = [
  { count: 5, keys: ["1", "2", "3", "4", "5"] },
  { count: 2, keys: ["yes", "no"] },
  { count: 10, keys: ["happy", "unhappy"] }
]

function normalize(label: string): string {
  return label.normalize("NFD").replace(/[̀-ͯ]/g, "").trim().toLowerCase()
}

//List the scales with at least two identical custom labels in a language
export function getScaleLabelDuplicates(
  options: { [key: string]: any },
  languages: string[]
): { count: number; language: string; label: string }[] {
  const duplicates: { count: number; language: string; label: string }[] = []

  SCALES.forEach((scale) => {
    if (!options["response" + scale.count + "Label"]) return

    languages.forEach((language) => {
      const seen: { [normalized: string]: boolean } = {}
      for (const key of scale.keys) {
        const label = options["response" + scale.count + "Label_" + key + "_" + language]
        if (typeof label !== "string" || !normalize(label)) continue
        if (seen[normalize(label)]) {
          duplicates.push({ count: scale.count, language, label: label.trim() })
          break
        }
        seen[normalize(label)] = true
      }
    })
  })

  return duplicates
}

//Scales with custom labels filled in a language but not completely in another one (the default text would be displayed)
export function getScaleLabelMissing(
  options: { [key: string]: any },
  languages: string[]
): { count: number; language: string; missing: number }[] {
  const result: { count: number; language: string; missing: number }[] = []
  if (languages.length < 2) return result

  SCALES.forEach((scale) => {
    if (!options["response" + scale.count + "Label"]) return

    const filled = (language: string) =>
      scale.keys.filter((key) =>
        normalize(String(options["response" + scale.count + "Label_" + key + "_" + language] || ""))
      ).length
    const counts = languages.map(filled)
    if (Math.max(...counts) === 0) return

    languages.forEach((language, i) => {
      if (counts[i] < scale.keys.length) {
        result.push({ count: scale.count, language, missing: scale.keys.length - counts[i] })
      }
    })
  })

  return result
}
